import { readWaterJSON, writeWaterJSON } from './waterStorage'
import { loadActiveContextSelection, persistActiveContextSelection } from './activeContextSelection'

type DashboardSelection = {
  farmId: string
  productionUnitId: string
  lotId: string
}

const DASHBOARD_STORAGE_KEYS = {
  farmId: 'dashboard:selectedFarmId',
  productionUnitId: 'dashboard:selectedProductionUnitId',
  lotId: 'dashboard:selectedLotId'
} as const

export const loadDashboardSelection = (): DashboardSelection => ({
  farmId: (() => {
    const active = loadActiveContextSelection().farmId
    if (active) return active
    const stored = readWaterJSON<string | null>(DASHBOARD_STORAGE_KEYS.farmId, null) ?? ''
    return stored
  })(),
  productionUnitId: (() => {
    const active = loadActiveContextSelection().productionUnitId
    if (active) return active
    const stored = readWaterJSON<string | null>(DASHBOARD_STORAGE_KEYS.productionUnitId, null) ?? ''
    return stored
  })(),
  lotId: (() => {
    const active = loadActiveContextSelection().lotId
    if (active) return active
    const stored = readWaterJSON<string | null>(DASHBOARD_STORAGE_KEYS.lotId, null) ?? ''
    return stored
  })()
})

export const persistDashboardSelection = (selection: Partial<DashboardSelection>): void => {
  const activeContextSelection: Partial<DashboardSelection> = { ...selection }
  if (activeContextSelection.productionUnitId === '__all__') {
    activeContextSelection.productionUnitId = ''
    if (!('lotId' in selection)) {
      activeContextSelection.lotId = ''
    }
  }

  if ('farmId' in selection) {
    writeWaterJSON<string | null>(DASHBOARD_STORAGE_KEYS.farmId, selection.farmId ? selection.farmId : null)
  }
  if ('productionUnitId' in selection) {
    writeWaterJSON<string | null>(
      DASHBOARD_STORAGE_KEYS.productionUnitId,
      selection.productionUnitId ? selection.productionUnitId : null
    )
  }
  if ('lotId' in selection) {
    writeWaterJSON<string | null>(DASHBOARD_STORAGE_KEYS.lotId, selection.lotId ? selection.lotId : null)
  }

  persistActiveContextSelection(activeContextSelection)
}
